import { getApiInstance } from '../helpers';

const uploadFile = async (
  file: File,
  newName: string,
  ticketId: string,
) => {
  const formData: FormData = new FormData();

  formData.append('file', file, newName);
  return await getApiInstance(true, { ticketId })
    .post('/ticket/upload-file', formData)
    .then((res) => {
      // the old version, set from_addon to false after too
      // not sure if still have to do that
      console.info('/upload-file result', res);
      return res.data;
    });
};

export const fileService = {
  uploadFile,
};
